import { render, staticRenderFns } from "./medical-popin.vue?vue&type=template&id=312789f8"
import script from "./medical-popin.vue?vue&type=script&lang=js"
export * from "./medical-popin.vue?vue&type=script&lang=js"
import style0 from "./medical-popin.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports